var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "right", width: "320", trigger: _vm.trigger } },
    [
      _c("div", { staticClass: "summary-report-popover" }, [
        _c("h3", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.summaryFields, function (field) {
            return _c(
              "div",
              {
                key: field.path,
                staticClass: "summary-lines",
                staticStyle: { "font-size": "smaller" },
              },
              [
                _c(
                  "div",
                  { staticClass: "grid", staticStyle: { padding: "7px 0px" } },
                  [
                    _c("div", { staticClass: "span-6" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "inline-block",
                            float: "left",
                          },
                        },
                        [_vm._v(" " + _vm._s(field.label))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "span-6" },
                      [
                        _c(
                          "el-tag",
                          {
                            staticStyle: {
                              display: "inline-block",
                              float: "right",
                            },
                            attrs: { size: "small", type: "info" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.reportProxy(field.path)) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.dataFound
          ? _c("div", { staticClass: "flex justify-center iperf-timestamp" }, [
              _c("span", [_vm._v(_vm._s(_vm.timestamp))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.dataFound
          ? _c(
              "div",
              [
                _c("el-table", {
                  staticStyle: { width: "100%" },
                  attrs: { data: [] },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          staticStyle: { display: "inline-block" },
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _vm._t("default", function () {
            return [_c("i", { staticClass: "el-icon-info sr_summary-icon" })]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }